<template>
    <div>
        <div class="object object--account block">
            <div class="object__table">
                <div class="object__cell object__cell--number h5">
                    <div class="object__label">Номер лицевого счета:</div>
                    <div class="object__value status-primary h2">{{AccountNumber}}</div>

                    <div v-if="SAPAccountId > 0" class="object__value ex-small">( Новый ЛС: {{SAPAccountId}} )</div>
                    <div v-if="SAPAccountId > 0" class="cb-input__label ex-small">г.Абкан</div>
                </div>
                <div class="object__cell object__cell--title h5">
                    <div class="object__label">{{ ContragentShortName }}</div>
                    <div class="object__label">Номер договора:</div>
                    <div class="object__value" v-if="Division.Id == 23">«Холодное водоснабжение и водоотведение»</div>
                    <div v-else>«Теплоснабжение и поставка горячей воды»</div>
                    <div class="object__value">№ {{ ContractNumber }} от {{ ContractDate | formatDate }}г. c {{Division.Caption}} </div>

                </div>
                <div class="object__cell object__cell--sm object__cell--right h5">
                    <div class="object__label">Задолженность по ЛС:</div>
                    <div class="object__value h3"> {{ Balans.BalansSum | ruF2 }} ₽</div>
                </div>
            </div>
            <div class="object__right">
                <div class="object__buttons">
                    <a class="object__ctrl button button--th-ctrl" href="/UL/equipment/equipments">Передать<br>показания</a>
                    <a v-if="PayEnabled" class="object__ctrl button button--th-main" href="/UL/payment/index/">Оплатить</a>
                    <div v-else class="object__ctrl" style="display:block; text-align:center">Оплата<br />недоступна</div>
                </div>
                <div class="object__toggle">
                    <a class="collapse-link collapse-link--second link link--underline " v-bind:href="'#'+objId" data-toggle="collapse">
                        <span class="link__text">Состояние расчетов</span>
                        <span class="link__icon fab-icon">
                            <i class="icon icon--angle-down"></i>
                        </span>
                    </a>
                </div>
            </div>
        </div>
        <div class="object-info accordion-body collapse" v-bind:id="objId">
            <div class="object-info__inner accordion-body__inner">
                <div class="object-info__section object-info__section--short block">
                    <div class="request-table request-table--account">
                        <div class="request-table__row request-table__row--head h5">
                            <div class="request-table__cell">Тип начисления</div>
                            <div class="request-table__cell">Задолженность <br>на начало месяца</div>
                            <div class="request-table__cell">Авансовые начисления <br> текущего месяца</div>
                            <div class="request-table__cell">Оплачено <br>в текущем месяце</div>
                            <div class="request-table__cell">Задолженность <br> на&nbsp;{{ deptDate | formatDate }}</div>
                        </div>
                        <section v-for="invoice in Invoices">
                            <div class="request-table__row h5" v-bind:class="invoice.InvoiceType.Id==-1 ? 'request-table__row--total' : ''">
                                <div class="request-table__cell request-table__cell--title ex-small">
                                    {{invoice.InvoiceType.Type}}
                                </div>
                                <div class="request-table__cell">
                                    <div class="request-table__label">Задолженность <br>на начало месяца </div>
                                    {{invoice.DeptStart  | ruF2}} ₽
                                </div>
                                <div class="request-table__cell">
                                    <div class="request-table__label">Авансовые начисления <br> текущего месяца</div>
                                    {{invoice.AdvanceAccrual  | ruF2}} ₽
                                </div>
                                <div class="request-table__cell">
                                    <div class="request-table__label">Оплачено <br>в текущем месяце</div>
                                    {{invoice.PayInPeriod  | ruF2}} ₽
                                </div>
                                <div class="request-table__cell">
                                    <div class="request-table__label">Задолженность <br> на&nbsp;{{ deptDate | formatDate }}</div>
                                    {{invoice.DeptEnd | ruF2}} ₽
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>
        <div class="objects__info block">
            <div class="account-info">
                <div v-if="payordercount > 0" class="account-info__item">
                    <div class="account-info__label">Порядок расчета по договору:</div>
                    <div class="account-info__value">{{payorderstr}}</div>
                </div>
                <div class="account-info__item">
                    <div class="account-info__label">Дата окончательного расчёта:</div>
                    <div class="account-info__value">до 10 числа следующего месяца</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
    export default {
        components: {
        },
        props: {
            account: {
                type: Object,
                default: function () {
                    return {
                        AccountNumber: "000000000000",
                        SAPAccountId: 0,
                        ContragentShortName: "Пустой компонент",
                        ContractNumber: "Договор поставки тепла",
                        ContractDate: "20.09.2018",
                        ContractRSO: "20.09.2018",
                        Balans: { AccountId: 2833899, DivisionId: 80, BalansSum: 994952.6 },
                        Division: { Caption: '' },
                        Invoices: {
                            AccountId: 2833899,
                            PeriodStart: "2019-10-01T00:00:00",
                            PeriodEnd: "2019-10-31T00:00:00",
                            InvoiceType: {
                                Id: 62,
                                Type: "Пени"
                            },
                            DeptStart: 4737.24,
                            AdvanceAccrual: 0.0,
                            PayInPeriod: 0.0,
                            DeptEnd: 4737.24
                        },
                        ContractOrder: {
                            DatabaseId: "Omnis_NSK_LKK",
                            DivisionId: 80,
                            AccountId: 2833899,
                            PayPeriods: {
                                Order: 0,
                                Persent: 0,
                                Day: 0
                            }
                        },
                        PayEnabled: true
                    };
                }
            }
        },
        data() {
            return {
                AccountNumber: this.account.AccountNumber,
                SAPAccountId: this.account.SAPAccountId,
                PayEnabled: this.account.PayEnabled,
                ContragentShortName: this.account.ContragentShortName,
                Division: this.account.Division,
                Balans: this.account.Balans,
                Invoices: this.account.Invoices,
                ContractOrder: this.account.ContractOrder,
                ContractNumber: this.account.ContractNumber,
                ContractDate: this.account.ContractDate,
                ContractRSO: this.account.ContractRSO,
                deptDate: Date.now()
            };
        },
        filters: {
            ruF2(number) {
                if (number === null) return 0;
                return number.toLocaleString('ru-RU');
            },

            formatDate(value) {
                if (value) {
                    return moment(value).format('DD.MM.YYYY');
                }
                return "";
            }
        },
        computed: {
            payorderstr() {
                var str = '';
                var self = this;
                this.ContractOrder.PayPeriods.forEach(function (item) {
                    if (item.Order !== 0) {
                        str += item.Order + '-й этап: до ' + item.Day + ' числа — ' + item.Persent + '% от общей плановой стоимости;';
                        item.Order == self.ContractOrder.PayPeriods.length - 1 ? str += '' : str += ' '
                    }
                });
                return str;
            },
            payordercount() {
                var cnt = 0;
                this.ContractOrder.PayPeriods.forEach(function (item) {
                    if (item.Order !== 0) cnt++;
                });
                return cnt;

            },

            SAPAccount() {
                return this.SAPAccountId > 0;
            },

            objId() {
                return 'objInfo_' + this.AccountNumber + '_' + this.account.DatabaseId + '_' + this.account.DivisionId;


            }
        }
    }

</script>

<style>
</style>


// WEBPACK FOOTER //
// Scripts/app/sts/requestfl/DeclarerInfo.vue